import Modal from 'react-modal'
import '../login/sass/app.scss'
import './login-popup.scss'
import { FormattedMessage } from 'react-intl'

export default function AdventureRequirementsPopup({
  isOpen,
  closeModal,
  requirements,
}) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      ariaHideApp={false}
      className='Modal react-popup form-popup'
      overlayClassName='Overlay'
      contentLabel='Activity requirements popup'
    >
      <span className='close-btn' onClick={closeModal} />
      <h3 className='mtn'>
        <FormattedMessage id='requirements' defaultMessage='Requirements' />
      </h3>
      <ul className='circled-list mts'>
        {requirements &&
          requirements.map((requirement) => (
            <li key={requirement}>{requirement}</li>
          ))}
      </ul>
    </Modal>
  )
}
